import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// dashboard summary API
export const fetchDashboardSummary = createAsyncThunk(
  'dashboard/fetchSummary',
  async ({ start, end } = {}) => {
    const params = {};
    if (start) params.start = start;
    if (end) params.end = end;
    const response = await axios.get('/v1/dashboard/summary', { params });
    return response.data;
  }
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    data: null,
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardSummary.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchDashboardSummary.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchDashboardSummary.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error;
      });
  },
});

export default dashboardSlice.reducer;